<template>
  <stacked-card>
    <notification-card compact icon="box" :icon-class="`has-text-${variant}`">
      <template #title>
        <font-awesome-icon :icon="icon" :class="`has-text-${variant} mr-2`" />
        {{ cleanName }}
      </template>
      <b-taglist v-if="s.phoneNumber || s.aad_user">
        <b-tag size="is-medium" :class="`is-${variant}`" v-if="s.phoneNumber">
          <font-awesome-icon icon="phone-flip" class="mr-2"/>
          {{ s.phoneNumber }}
        </b-tag>
        <b-tag size="is-medium" :class="`is-${variant}`" v-if="s.aad_user">
          <font-awesome-icon :icon="['fab', 'microsoft']" class="mr-2"/>
          {{ s.aad_user }}
        </b-tag>
      </b-taglist>
      <p>Monitoring a {{ deviceType }}.</p>
    </notification-card>
    <template #buttons>
      <b-button class="stacked-button" @click="view" :type="`is-${variant}`">
        <font-awesome-icon icon="sliders"/>
      </b-button>
      <b-button class="stacked-button is-dark" @click="search">
        <font-awesome-icon icon="search"/>
      </b-button>
    </template>
  </stacked-card>
</template>

<script>
import { deviceIcon, iconVariation, isMobile } from '@/services/devices'
export default {
  props: {
    s: Object
  },
  computed: {
    cleanName () {
      if ((this.s.ownerName || '').trim().length > 0) return this.s.ownerName
      return this.s.device.replace(/\.(users|machines)\.vipro$/, '')
    },
    icon () { return deviceIcon(this.s.device) },
    variant () { return iconVariation(this.s.device) },
    deviceType () { return isMobile(this.s.device) ? 'mobile device' : 'desktop user' }
  },
  methods: {
    view () {
      this.$router.push({ name: 'subject', params: { id: this.s.device } })
    },
    search () {
      this.$store.commit('filters/resetWith', { devices: [this.s.device] })
      this.$router.push({ name: 'search' })
    }
  }
}
</script>